Vue.component('ack-image', {
   delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
   template: '#ack-image',
   mounted() {
     console.log('ack-image mounted')


   },
   props:{
     imageInfo: { // :product-info
       type: Object,
       required: true
     }
   },
   computed: {

   },
   data() {
     return {
     }
   },
   methods: {


   },
   beforeDestroy() {

   },
   watch: {
     isMobile: {
       handler() {


       },
       deep: false
     }
   }
 })